export function Background() {
  return (
    <div className="background">
      <div className="background__sky"></div>
      <div className="background__stars"></div>
    </div>
  );
}
